module.exports = __webpack_public_path__ + "static/CarolinaRitzler-6ba67deb323d0824ffcc85270d705919.jpg";